export default __webpack_public_path__ + "static/media/openMaps.9f81930e.svg";